import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { UsuarioSharedModule } from '../../usuario';
import { MotivoPerdaVendaSelectModule } from '../../motivo-perda-venda/select';
import { PedidoCancelamentoInfoComponent } from './info';
import { ClienteFormInputDisabledModule } from '../../pessoa/cliente/form-input-disabled';
import { RepresentanteFormInputDisabledModule } from '../../pessoa/representante/components/form-input-disabled';

import { PedidoCancelamentoModalComponent } from './pedido-cancelamento-modal.component';

@NgModule({
    imports: [
        SharedModule,
        UsuarioSharedModule,
        MotivoPerdaVendaSelectModule,
        ClienteFormInputDisabledModule,
        RepresentanteFormInputDisabledModule
    ],
    declarations: [
        PedidoCancelamentoModalComponent,
        PedidoCancelamentoInfoComponent
    ],
    exports: [
        PedidoCancelamentoModalComponent,
        PedidoCancelamentoInfoComponent
    ]
})
export class PedidoCancelamentoModule { }
